import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'weight', 'weightUnit', 'protocol', 'goal',
    'maintenanceDose', 'loadingSection', 'loadingDose', 'splitDose',
    'saturationTime', 'monthlyGrams', 'monthlyCost'
  ]

  connect() {
    this.calculate()
  }

  calculate() {
    let weight = parseFloat(this.weightTarget.value) || 75
    const unit = this.weightUnitTarget.value
    const protocol = this.protocolTargets.find((r) => r.checked)?.value || 'standard'

    // Convert to kg if needed
    if (unit === 'lbs') {
      weight /= 2.205
    }

    // Standard maintenance dose: 3-5g per day (0.03-0.05 g/kg, max ~5g)
    // Research shows 3-5g is effective for most people
    let maintenanceDose = Math.min(5, Math.max(3, Math.round(weight * 0.04)))

    // For larger individuals, may benefit from slightly higher dose
    if (weight > 100) {
      maintenanceDose = 5
    }

    this.maintenanceDoseTarget.textContent = maintenanceDose

    // Loading protocol
    if (protocol === 'loading') {
      this.loadingSectionTarget.classList.remove('hidden')
      // Loading dose: ~0.3g/kg/day for 5-7 days
      const loadingDose = Math.round(weight * 0.3)
      this.loadingDoseTarget.textContent = loadingDose
      this.splitDoseTarget.textContent = Math.round(loadingDose / 4)
      this.saturationTimeTarget.textContent = '5-7 days'
    } else {
      this.loadingSectionTarget.classList.add('hidden')
      this.saturationTimeTarget.textContent = '3-4 weeks'
    }

    // Monthly supply calculation
    const monthlyGrams = maintenanceDose * 30
    this.monthlyGramsTarget.textContent = monthlyGrams

    // Cost estimate (creatine monohydrate is very cheap)
    // ~$0.02-0.05 per gram for quality creatine
    const costLow = Math.round(monthlyGrams * 0.02)
    const costHigh = Math.round(monthlyGrams * 0.05)
    this.monthlyCostTarget.textContent = `${costLow}-${costHigh}`
  }
}
